export enum ChartConfigType {
    General = 'General',
    YAxis = 'Y Axis',
    XAxis = 'X Axis',
    Series = 'Series', // use for pie/donut/radial
}
